import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {podDetailActions} from "../../slice/efe/podDetailSlice";
import {
    ControlCommandsListResponse, ControlDataResponse, PodEventsListResponse,
    PodMetricsResponse, EnapKepEventsListResponse, InverterDataGridResponse, MeterDataGridResponse,
    MeterInverterDataListResponse,
    PodEfeDataResponse,
    PodEnergyBalanceResponse, RatedPowerResponse
} from "../../data/podDetail";

export const getPodDetails = (id: number): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/data?id=${id}`)
            .then((res: AxiosResponse<PodEfeDataResponse>) => {
                dispatch(podDetailActions.setPodEfeData(res.data.podDeviceData));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getMeterInverterDetailsList = (id: number): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/meter-inverter/data?id=${id}`)
            .then((res: AxiosResponse<MeterInverterDataListResponse>) => {
                dispatch(podDetailActions.setMeterInverterDataList(res.data.meterInverterDataList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getPodEnergyBalance = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/energy-balance?podId=${podId}`)
            .then((res: AxiosResponse<PodEnergyBalanceResponse>) => {
                dispatch(podDetailActions.setPodEnergyBalance(res.data.podEnergyBalance));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getEfeMetrics = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));
        dispatch(podDetailActions.setMetricsLoading(true));

        Axios.get(`/efe/pod-details/pod-metrics?podId=${podId}`)
            .then((res: AxiosResponse<PodMetricsResponse>) => {
                dispatch(podDetailActions.setPodMetrics(res.data.podMetrics));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getMeterDataGrid = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/meter-data?podId=${podId}`)
            .then((res: AxiosResponse<MeterDataGridResponse>) => {
                dispatch(podDetailActions.setMeterDataGrid(res.data.meterDataGrid));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getInverterDataGrid = (podId: string, deviceName: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        try {
            const res: AxiosResponse<InverterDataGridResponse> = await Axios.get(
                `/efe/pod-details/inverter-data?podId=${podId}&deviceName=${deviceName}`
            );

            dispatch(podDetailActions.setInverterDataGrid(res.data.inverterDataGrid));
            return res.data.inverterDataGrid;
        } catch (err) {
            const error = err as AxiosError;
            if (error.response?.status === 400) {
                const resp: any = error.response.data;
                dispatch(podDetailActions.setError(resp));
            }
            throw error;
        }
    };
};

// export const getInverterDataGrid = (podId: string, deviceName: string): any => {
//     return async (dispatch: any) => {
//         dispatch(podDetailActions.setLoading(true));
//
//         Axios.get(`/efe/efe-details/inverter-data?podId=${podId}&deviceName=${deviceName}`)
//             .then((res: AxiosResponse<InverterDataGridResponse>) => {
//                 dispatch(podDetailActions.setInverterDataGrid(res.data.inverterDataGrid));
//                 return res.data.inverterDataGrid;
//             })
//             .catch((err: AxiosError) => {
//                 if (err.response) {
//                     if (err.response.status === 400) {
//                         const resp: any = err.response.data;
//                         dispatch(podDetailActions.setError(resp));
//                     }
//                 }
//             });
//     };
// };

export const getControlCommands = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/control-commands?podId=${podId}`)
            .then((res: AxiosResponse<ControlCommandsListResponse>) => {
                dispatch(podDetailActions.setControlCommandsList(res.data.controlCommandsList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getEnapKepEvents = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/enapkep-events?podId=${podId}`)
            .then((res: AxiosResponse<EnapKepEventsListResponse>) => {
                dispatch(podDetailActions.setEnapKepEventsList(res.data.enapKepEventsList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getEfeEvents = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/pod-events?podId=${podId}`)
            .then((res: AxiosResponse<PodEventsListResponse>) => {
                dispatch(podDetailActions.setPodEventsList(res.data.podEventsList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getControlData = (podId: string, commandId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/control-data?podId=${podId}&commandId=${commandId}`)
            .then((res: AxiosResponse<ControlDataResponse>) => {
                dispatch(podDetailActions.setControlData(res.data.controlData));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};

export const getInverterRatedPower = (podId: string): any => {
    return async (dispatch: any) => {
        dispatch(podDetailActions.setLoading(true));

        Axios.get(`/efe/pod-details/inverter-rated?podId=${podId}`)
            .then((res: AxiosResponse<RatedPowerResponse>) => {
                dispatch(podDetailActions.setRatedPower(res.data.ratedPower));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(podDetailActions.setError(resp));
                    }
                }
            });
    };
};